"use strict";

(function ($) {

    // TODO Youtube Iframe
    $('.youtubeiFrame').on('click', function () {
      if($(this).data('iframeurl')){
        $(this).find('img').remove();
        $(this).append('<iframe src="' + $(this).data('iframeurl') + '" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width: 100%;height: 300px;"> </iframe>');
      }
    });

    // TODO FAQ Sorting Functionality
    $('#filters a').on('click', function(e){
        e.preventDefault();
        let term = $(this).data('filter');
        $(this).addClass('faq-filter-active').siblings().removeClass('faq-filter-active');
        if(term === 'all') {
            $('#items li').css('display', 'inline-block');
        } else {
            $('#items li').hide();
            $('#items li[data-filter-item="'+term+'"]').css('display', 'inline-block');;
        }
    });

    // TODO Redirect Thanks Page
    document.addEventListener( 'wpcf7mailsent', function( event ) {
        let isEsPage = $("body").hasClass("es-page");
        window.location.href = isEsPage ? '/es/gracias/' : '/thank-you/';
    }, false);
  
    // TODO Scroll To ID
    $(document).on('click', 'a[href^=\\#]', function(e){
        let el = $($(this).attr('href'));
        if(el.length && el.offset()) { // one of those may be unnecessary
            e.preventDefault();
        $('html, body').animate({
            scrollTop: el.offset().top - $('header').height()
           }, 2000);
        }
    });

    // TODO Menu mobile
    $('button.burger').on('click', function () {
        $('body').toggleClass('overflowGlobal');
        $('.header-nav').toggleClass('active');
        $(this).toggleClass('burger-active');
    });

    // TODO Add functionality for the mobile menu open
    $('.header .genesis-nav-menu > ul > .menu-item-has-children').on('click', function () {
        if($('.header').hasClass('header-mobile')) {
            $(this).toggleClass('open').children().last().slideToggle(150);
        } else {
            $(this).toggleClass('open');
        }
    });

    $('.header .genesis-nav-menu > ul > .menu-item-has-children .menu-item-has-children').on('click', function (event) {
        event.stopPropagation();
        if($('.header').hasClass('header-mobile')) {
            $(this).toggleClass('open').children().last().slideToggle(150);
        } else {
            $(this).toggleClass('open');
        }
    });

    // TODO Header active class, CTA on mobile and btn up fixed elements
    let lastScrollTop = 0;
    function menuFixed() {
        // Header Active Class
        if ($(window).scrollTop() > 20) {
            $('.header').addClass('header-active');
        } else {
            $('.header').removeClass('header-active');
        }
        // CTA on mobile show/hide
        let st = $(this).scrollTop();
        let header = $('header.header');
        if(header.hasClass('header-mobile')) {
            if($(window).scrollTop() > 350) {
                if (st >= lastScrollTop){
                    header.addClass('header-scroll');
                } else {
                    header.removeClass('header-scroll')
                }
            }
            lastScrollTop = st;
        }
        // Btn Up Active Show/Hide
        if ($(this).scrollTop() > 500) {
            $('#scrollToTop').addClass('btn-up-active');
        } else {
            $('#scrollToTop').removeClass('btn-up-active');
        }
    }

    $(window).bind('scroll', menuFixed);

    // TODO scroll body to 0px on click
    $('#scrollToTop').on('click', function (event) {
        event.preventDefault();
        $('body,html').animate({
            scrollTop: 0
        }, 700);
        $(this).removeClass('btn-up-active');
    });

    // Sticky sidebar form: stays first in sidebar, reappears fixed after other widgets scroll away
    (function () {
        var $aside = $('body:not(.page-template-front-page):not(.page-module):not(.single-attorney) .content-sidebar-wrap aside');
        if (!$aside.length) return;

        var $form = $aside.find('.widget:first-child');
        var $main = $aside.siblings('main');
        if (!$form.length || !$main.length) return;

        var $others = $aside.find('.widget:not(:first-child)');
        if (!$others.length) return;

        // Placeholder keeps form's space in the layout when form goes fixed
        var $placeholder = $('<div class="sidebar-form-placeholder">').insertAfter($form);

        // state: 'normal' | 'fixed' | 'pinned' | 'leaving-normal' | 'leaving-pinned'
        var state = 'normal';
        var leaveTimeout = null;
        var lastFormH = 0;
        var lastAsideWidth = 0;
        var lastMainBottom = 0;

        function resetForm() {
            $form.removeClass('is-fixed is-pinned is-entering is-leaving').css({ position: '', top: '', left: '', width: '' });
            $form.find('.cmn-g-form').css({ maxHeight: '' });
            $placeholder.hide();
            state = 'normal';
        }

        function pinForm(asideWidth, formH) {
            $form.removeClass('is-fixed is-entering is-leaving').addClass('is-pinned').css({
                position: 'absolute',
                top: '',
                width: asideWidth + 'px'
            });
            $placeholder.css('height', formH).show();
            state = 'pinned';
        }

        function updateFormSticky() {
            if ($(window).width() <= 1024) {
                clearTimeout(leaveTimeout);
                resetForm();
                return;
            }

            // Skip entirely if main content is shorter than the sidebar - nothing to scroll past
            if ($main.outerHeight(true) <= $aside.outerHeight(true) + 800) {
                clearTimeout(leaveTimeout);
                resetForm();
                return;
            }

            var headerH = $('header.header').outerHeight() || 0;
            var stickyTop = headerH + 15;
            var scrollTop = $(window).scrollTop();
            var formH = $form.outerHeight(true);
            var asideWidth = $aside.innerWidth();
            var mainBottom = $main.offset().top + $main.outerHeight(true);

            // Trigger: all other widgets have scrolled above viewport
            var othersBottom = $others.last().offset().top + $others.last().outerHeight(true);
            var shouldStick = scrollTop + stickyTop >= othersBottom;
            // Stop: form would overflow content bottom
            var shouldPin = scrollTop + stickyTop + formH >= mainBottom;

            lastFormH = formH;
            lastAsideWidth = asideWidth;
            lastMainBottom = mainBottom;

            if (shouldPin) {
                if (state === 'fixed') {
                    // Slide up out of view first, then dock it into the pinned spot
                    clearTimeout(leaveTimeout);
                    $form.addClass('is-leaving');
                    state = 'leaving-pinned';
                    leaveTimeout = setTimeout(function () {
                        pinForm(lastAsideWidth, lastFormH);
                    }, 400);
                } else if (state !== 'pinned' && state !== 'leaving-pinned') {
                    pinForm(asideWidth, formH);
                }
            } else if (shouldStick) {
                var availableH = $(window).height() - stickyTop;
                var $inner = $form.find('.cmn-g-form');

                if (state !== 'fixed') {
                    clearTimeout(leaveTimeout);
                    // Slide in from above: set the starting position with transitions
                    // disabled first, then release on the next frame so it animates down.
                    $form.removeClass('is-pinned is-leaving').addClass('is-fixed is-entering').css({
                        position: 'fixed',
                        top: stickyTop + 'px',
                        width: asideWidth + 'px'
                    });
                    // eslint-disable-next-line no-unused-expressions
                    $form.get(0).offsetHeight; // force reflow so the entering state is applied before removal
                    requestAnimationFrame(function () {
                        $form.removeClass('is-entering');
                    });
                } else {
                    $form.css({ top: stickyTop + 'px', width: asideWidth + 'px' });
                }

                $inner.css({ maxHeight: formH > availableH ? availableH + 'px' : '' });
                $placeholder.css('height', formH).show();
                state = 'fixed';
            } else if (state === 'fixed' || state === 'pinned') {
                // Slide back up out of view before dropping the form back into normal flow
                clearTimeout(leaveTimeout);
                $form.removeClass('is-pinned').addClass('is-fixed is-leaving').css({
                    position: 'fixed',
                    top: stickyTop + 'px',
                    width: asideWidth + 'px'
                });
                state = 'leaving-normal';
                leaveTimeout = setTimeout(resetForm, 400);
            } else if (state !== 'leaving-normal' && state !== 'leaving-pinned') {
                resetForm();
            }
        }

        $(window).on('scroll resize', updateFormSticky);
        updateFormSticky();
    }());

    // TODO HD Modal
    $('.open-hd-modal').on('click', function () {
        console.log(this);
        let hdModalContentType = $(this).data('hd-modal-content-type');
        let hdModalContent = $(this).data('hd-modal-content');
        let hdModalHTML = '<div class="hd-modal">';
        let hdContainer = $('#hd-modal-container .modal-container-video');
        hdModalHTML +=
            '<div class="hd-modal-close">' +
            '<svg clip-rule="evenodd" width="24" height="24" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z" fill="#fff"/></svg></div>';

        if (hdModalContentType === 'youtube') {
            hdModalHTML =
                hdModalHTML +
                '<div class="hd-modal-before"><iframe src="https://www.youtube.com/embed/' +
                hdModalContent +
                '?autoplay=1&mute=1" allow="autoplay" allowfullscreen></iframe></div>';
        }
        if (hdModalContentType === 'file') {
            hdModalHTML =
                hdModalHTML +
                '<div class="hd-modal-before"><iframe src="' +
                hdModalContent +
                '?autoplay=1&mute=1" allow="autoplay" allowfullscreen></iframe></div>';
        } else if (hdModalContentType === 'wistia') {
            hdModalHTML += `<div class="hd-modal-before"><iframe src="https://fast.wistia.net/embed/iframe/${hdModalContent}" allowfullscreen frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" allow="autoplay; fullscreen" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none;"></iframe></div><script src="https://fast.wistia.com/embed/medias/${hdModalContent}.jsonp" async></script><script src="https://fast.wistia.com/assets/external/E-v1.js" async></script>`;
        } else {
            hdModalHTML = hdModalHTML + hdModalContent;
        }
        hdContainer.append(hdModalHTML);
        $('.modal-container').addClass('active');
    });

    $(document).on('click', '.hd-modal-close, #hd-modal-container', function (e) {
        if (
            ($(this).is('#hd-modal-container') && !$(e.target).closest('.hd-modal').length) ||
            $(this).hasClass('hd-modal-close')
        ) {
            $('.modal-container').removeClass('active');
            $('#hd-modal-container .modal-container-video').empty();
        }
    });

    // TODO Table of content
    $(".blogSidebar .contents").on("click", function () {
        $(this).toggleClass("active");
        $('.contents-wrap').slideToggle(500);
        var isEsPage = $("body").hasClass("es-page");
        if ($(this).hasClass("active")) {
            $(".js-fix").text(isEsPage ? "Cerrar" : "Close");
        } else {
            $(".js-fix").text(isEsPage ? "Ampliar" : "Expand");
        }
    });

    // TODO FAQs Accordion
    $(".faq-section__item-btn").on("click", function () {
        if ($(this).hasClass("active")) {
            $(this).removeClass("active").next().slideUp(500);
            return false;
        }
        $(".faq-section__item-btn").removeClass("active").next().slideUp(500);
        $(this).addClass("active").next().slideDown(500);
    });

    const legalTeamSwiper = new Swiper(".legal-team-slider .swiper", {
        slidesPerView: 4,
        spaceBetween: 5,
        speed: 1000,
        loop: true,
        autoHeight: false,
        observeParents: true,
        observeSlideChildren: true,
        navigation: {
            nextEl: ".legal-team-slider .button-next",
            prevEl: ".legal-team-slider .button-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 5,
                spaceBetween: 20,
            },
            992: {
                slidesPerView: 6,
                spaceBetween: 20,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 20,
            }
        },
        on: {
            init: function () {
                updateLegalTeamActive(this.realIndex);
            },
            slideChange: function () {
                updateLegalTeamActive(this.realIndex);
            },
            click: function (swiper) {
                const realIdx = parseInt(swiper.clickedSlide?.dataset.swiperSlideIndex ?? swiper.realIndex);
                swiper.slideToLoop(realIdx);
            },
        },
    });

    function updateLegalTeamActive(index) {
        $(".legal-team-thumb").removeClass("active").eq(index).addClass("active");
        $(".legal-team-meta__attr").removeClass("active").eq(index).addClass("active");
    }

    // TODO Firm results — slider: 4 per view on desktop (>=992px), 2 on tablet (>=576px), 1 on mobile
    (function () {
        var selector = ".firm-results__slider.swiper";
        if (!document.querySelector(selector) || typeof Swiper === "undefined") {
            return;
        }
        new Swiper(selector, {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            speed: 600,
            grabCursor: true,
            navigation: {
                nextEl: ".firm-results__next",
                prevEl: ".firm-results__prev",
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 4,
                },
            },
        });
    })();

})(jQuery);